import React, { memo } from 'react';
import Link from 'next/link';
import styles from './index.module.scss';

const MyBrandListEmptyState = () => {
  return (
    <div className={styles.container}>
      <img src="//assets-oss.cbndata.com/cbndata-refactor-fe/FkLDx0LfKvw3VU5U4gpOuhFYMPyK.png" alt="暂未订阅解锁品牌" />
      <p className={styles.tips}>暂未订阅&解锁品牌</p>
      <Link href="/brand">
        <a target="_blank" className="reddish-orange-text-14">
          去品牌库看看
        </a>
      </Link>
    </div>
  );
};

export default memo(MyBrandListEmptyState);
